import Excel from "exceljs";
import { saveAs } from "file-saver";
import { toChinaDateString } from "../../../lib/chinaDate";

export const braunShippingListMeta = {
  hknVendorCode: "20625219",
  vendorPhoneNumber: "021-50595180",
  customerName: "博朗(上海)有限公司",
  to: "steven.lu@hankeno.com",
  vendorAlias: "SHJH",
  vendorName: "上海汉肯诺电子科技有限公司",
  driver: "司威峰",
  driverPhoneNumber: "18717751966",
};

export function shippingNumberDatePrefix(shippingNumber) {
  return shippingNumber?.slice(0, -2) || "";
}

export function receivingDateFromShippingNumber(shippingNumber) {
  const match = String(shippingNumber || "").match(/^SHJH(\d{4})(\d{2})(\d{2})/i);
  if (!match) return undefined;
  return `${match[1]}-${match[2]}-${match[3]}`;
}

export function bolNumberForItem(shippingNumber, itemNumber) {
  const serial = String(itemNumber * 1).padStart(2, "0");
  return `${shippingNumberDatePrefix(shippingNumber)}${serial}`;
}

function formatShippingDate(date) {
  return toChinaDateString(date) || date;
}

function poNumberWithoutPrefix(poNumber) {
  if (!poNumber) return "";
  return poNumber.includes("-") ? poNumber.split("-")[1] : poNumber;
}

export function toShippingListItems(items) {
  return items
    .slice()
    .sort((a, b) => {
      if (a.number !== b.number) return a.number > b.number ? 1 : -1;
      return a.itemNumber * 1 > b.itemNumber * 1 ? 1 : -1;
    })
    .map((item) => ({
      itemNumber: item.itemNumber,
      poNumber: poNumberWithoutPrefix(item.poNumber || item.po?.no),
      code: item.code || item.materialEntityRelation?.code,
      mpn: item.mpn || item.material?.mpn,
      palletQty: item.palletQty ?? item.qty ?? 0,
      packageQty: item.packageQty ?? item.qty ?? 0,
      remainder: item.remainder ?? 0,
      qty: item.qty,
      number: bolNumberForItem(item.number, item.itemNumber),
    }));
}

export async function downloadShippingList({ items, date, shippingNumber }) {
  if (!items?.length) return;

  const listItems = toShippingListItems(items);
  const number = shippingNumber || items[0]?.number;

  await saveShippingList({
    data: {
      meta: {
        ...braunShippingListMeta,
        date: formatShippingDate(date || items[0]?.date),
        shippingNumber: number,
      },
      items: listItems,
    },
  });
}

export async function saveShippingList({ data }) {
  const { buffer, filename } = await generateShippingListBuffer({ data });
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  saveAs(blob, filename);
}

export async function generateShippingListBuffer({ data }) {
  const { items, meta } = data || {};

  const {
    date,
    shippingNumber,
    vendorAlias,
    driver,
    driverPhoneNumber,
  } = meta || {};

  const arrivalDate =
    receivingDateFromShippingNumber(shippingNumber) || date;

  items.sort((a, b) => (a.itemNumber * 1 > b.itemNumber * 1 ? 1 : -1));

  const workbook = new Excel.Workbook();

  const sheet = workbook.addWorksheet(`page ${1}`, {
    pageSetup: {
      paperSize: 9,
      margins: {
        left: 0.4,
        right: 0.4,
        top: 0.4,
        bottom: 0.4,
        header: 0,
        footer: 0,
      },
      orientation: "landscape",
      horizontalCentered: true,
      fitToPage: false,
    },
    properties: {
      defaultRowHeight: 15,
    },
  });

  const rows = items.map((x) => [
    x.itemNumber,
    x.poNumber,
    "",
    x.code,
    x.mpn,
    "",
    "",
    x.palletQty,
    x.packageQty,
    x.remainder,
    x.qty,
    x.number,
    "",
  ]);

  const borderedRow = [
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
  ];

  sheet.columns = [
    { key: "itemNumber", width: 5 },
    { key: "poNumber", width: 18 },
    { key: "workingOrderNumber", width: 6 },
    { key: "code", width: 9 },
    { key: "mpn", width: 18 },
    { key: "batch", width: 11 },
    { key: "datecode", width: 7 },
    { key: "palletQty", width: 9 },
    { key: "packageQty", width: 9 },
    { key: "remainder", width: 8 },
    { key: "qty", width: 9 },
    { key: "number", width: 14 },
    { key: "note", width: 8 },
  ];

  sheet.addRow([`瀚睿科电子（上海）有限公司送货单`]);
  sheet.getRow(1).font = { size: 14 };
  sheet.getRow(1).height = 20;
  sheet.getRow(1).alignment = {
    vertical: "middle",
    horizontal: "center",
  };
  sheet.mergeCells("A1: M1");
  sheet.addRow(["", "CM No:", "", "", "", "", "", "", "", "", "", ""]);

  sheet.getRow(2).font = { size: 10 };
  sheet.addRow(
    [
      "",
      "SAP供应商号码:",
      "15385894",
      null,
      "",
      "供应商缩写: ",
      vendorAlias,
      null,
      "",
      "",
      "",
      "",
    ],
    "i"
  );

  sheet.addRow(
    [
      "",
      "From (来自): ",
      `瀚睿科电子（上海）有限公司`,
      null,
      null,
      "To (发送至): ",
      "博朗（上海）有限公司",
      null,
      null,
      "",
      "",
      "",
    ],
    "i"
  );
  sheet.addRow(
    ["", "发货日期:", date, null, "", "到货日期", arrivalDate, null, "", "", "", ""],
    "i"
  );
  sheet.addRow(
    [
      "",
      "申请人: ",
      driver,
      null,
      "",
      "申请人联系方式",
      driverPhoneNumber,
      null,
      "",
      "",
      "",
      "",
    ],
    "i"
  );
  sheet.addRow(
    ["", "收货人签名: ", "", "", "", "", "", "", "", "", "", ""],
    "i"
  );
  sheet.addRow(["", "实收日期: ", "", "", "", "", "", "", "", "", "", ""], "i");
  sheet.addRow(["", "备注: ", "", "", "", "", "", "", "", "", "", ""], "i");

  sheet.addRow();
  sheet.addRow();
  sheet.addRow();
  sheet.addRow([
    "项目号",
    "订单号",
    "工单号",
    "物料编号",
    "产品描述",
    "批次",
    "制造日期",
    "每板数量",
    "整板数量",
    "尾数",
    "总数量",
    "BOL(单号)",
    "备注",
  ]);

  sheet.getRow(13).font = { size: 8 };
  sheet.getRow(13).height = 12;
  sheet.getRow(13).alignment = {
    vertical: "middle",
    horizontal: "left",
  };

  borderedRow.forEach((x) => {
    sheet.getCell(`${x}13`).border = {
      top: { style: "thin" },
      left: { style: "thin" },
      bottom: { style: "thin" },
      right: { style: "thin" },
    };
  });

  sheet.addRows(rows, "i");

  if (items.length < 14)
    sheet.addRows(
      Array(14 - items.length)
        .fill()
        .map((y) => ["", "", "", "", "", "", "", "", "", "", "", "", ""]),
      "i"
    );

  const buffer = await workbook.xlsx.writeBuffer();
  const filename = `${shippingNumberDatePrefix(shippingNumber)}.xls`;

  return { buffer, filename };
}
